import type { DocumentTemplatePayload } from '@Application/Documents/Templates/Actions/documentTemplatesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `documentTypeId` is read off the `documentType` relation (`{ id }`): the label is resolved
 * against `DocumentTypesListView.labelOf`, never carried here. `currentVersionId` is read off the
 * `currentVersion` relation (`{ id }`); resolving the actual version object is
 * `DocumentTemplateVersionsListView`'s job, not this View's. `archivedAt === null` means the template
 * is active (`isArchived` is the negation).
 */
class DocumentTemplateView {
	readonly id: number;
	readonly name: string;
	readonly description: string | null;
	readonly documentTypeId: number;
	readonly archivedAt: string | null;
	readonly currentVersionId: number;

	constructor(payload: DocumentTemplatePayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.description = payload.description;
		this.documentTypeId = payload.documentType.id;
		this.archivedAt = payload.archivedAt;
		this.currentVersionId = payload.currentVersion.id;

		Object.freeze(this);
	}

	get isArchived(): boolean {
		return this.archivedAt !== null;
	}
}

export default DocumentTemplateView;
